import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LayoutContext } from '../../contexts/layout.context';
import { useNavigate } from 'react-router-dom';
import Button from '../../common/Buttons/Button';
import { authSelectors } from '../../store/selectors/auth';
import { getUserInfoThunk } from '../../store/thunks/profile';
import usePreviewFeature from '../../hooks/usePreviewFeature';
import PaymentResultV2 from './PaymentResultV2';
import successImage from '../../img/payment/payment-success.webp';

const PaymentSuccess = () => {
  const { setLayout } = useContext(LayoutContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = useSelector(authSelectors).token;
  const isV2 = usePreviewFeature('cabinet-v2');

  useEffect(() => {
    document.title = 'Реквізити | New Brain';
    setLayout({ page: 'Реквізити' });
  }, [setLayout]);

  useEffect(() => {
    if (token) {
      dispatch(getUserInfoThunk({ token }));
    }
  }, [token]);

  useEffect(() => {
    if (isV2) {
      return undefined;
    }

    let time = 2;
    const timer = setInterval(() => {
      if (time === 0) {
        navigate('/');
      }
      --time;
    }, 1000);

    return () => clearInterval(timer);
  }, [isV2]);

  const handlePage = () => {
    navigate('/');
  };

  if (isV2) {
    return (
      <PaymentResultV2
        tone="success"
        image={successImage}
        title="Дякуємо"
        accent="за оплату!"
        text="Наш менеджер зв’яжеться з Вами упродовж доби!"
        primary={{ label: 'До моїх курсів', onClick: () => navigate('/courses') }}
        secondary={{ label: 'Фінанси', onClick: () => navigate('/') }}
      />
    );
  }

  return (
    <div className='finances-message container'>
      <div className="finances__message finances__message--green">
        Дякуємо за оплату! <br></br>
        Наш менеджер звʼяжеться <br></br>
        з Вами упродовж доби! <br></br>
        Вітаємо Вас з правильним рішенням!
      </div>
      <div className="finances__btn">
        <Button buttonBg="green" onClick={handlePage}>Далі</Button>
      </div>
    </div>
  );
};

export default PaymentSuccess;